import { z } from "zod";
import { citationsSchema } from "./citation";
import { toolSchemas } from "./sseToolSchemas";

const base = { run_id: z.string(), sequence: z.number(), attempt_id: z.string().nullish() };

export const sseStartSchema = z.object({
  ...base,
  type: z.literal("start"),
  conversation_id: z.string().optional(),
  message_id: z.string().optional(),
  assistant_message_id: z.string().nullish(),
  mock: z.boolean().optional(),
  memory_ids: z.array(z.string()).optional(),
});

export const sseChunkSchema = z.object({
  ...base,
  type: z.literal("chunk"),
  text: z.string().default(""),
});

export const sseRestartSchema = z.object({
  ...base,
  type: z.literal("restart"),
});

export const { sseToolSchema, sseToolResultSchema } = toolSchemas(base);

export const sseDoneSchema = z.object({
  ...base,
  type: z.literal("done"),
  message_id: z.string().optional(),
  citations: citationsSchema.optional(),
  memory_ids: z.array(z.string()).optional(),
});

export const sseErrorSchema = z.object({
  ...base,
  type: z.literal("error"),
  message: z.string().optional(),
  code: z.string().optional(),
});
